export default class Discover {
  static init() {
    const containerDivs = document.querySelectorAll('.discover-container')

    function initializeClipPath(bgDiv, circleX, circleY, circleWidth) {
      bgDiv.style.clipPath = `circle(${
        circleWidth / 2
      }px at ${circleX}px ${circleY}px)`
    }

    function moveCircle(
      containerDiv,
      bgDiv,
      circleX,
      circleY,
      circleWidth,
      velocityX,
      velocityY
    ) {
      // Calculate the new circle position
      circleX += velocityX
      circleY += velocityY

      // Check for collision with container boundaries and bounce off if needed
      if (
        circleX - circleWidth / 2 <= 0 ||
        circleX + circleWidth / 2 >= containerDiv.offsetWidth
      ) {
        velocityX = -velocityX
      }
      if (
        circleY - circleWidth / 2 <= 0 ||
        circleY + circleWidth / 2 >= containerDiv.offsetHeight
      ) {
        velocityY = -velocityY
      }

      // Calculate the clip path to show the content inside the circle
      const clipPathValue = `circle(${
        circleWidth / 2
      }px at ${circleX}px ${circleY}px)`

      // Update the clip path value
      bgDiv.style.clipPath = clipPathValue

      return {circleX, circleY, velocityX, velocityY}
    }

    function animate(
      containerDiv,
      bgDiv,
      circleX,
      circleY,
      circleWidth,
      velocityX,
      velocityY
    ) {
      const circleProperties = moveCircle(
        containerDiv,
        bgDiv,
        circleX,
        circleY,
        circleWidth,
        velocityX,
        velocityY
      )
      requestAnimationFrame(() => {
        animate(
          containerDiv,
          bgDiv,
          circleProperties.circleX,
          circleProperties.circleY,
          circleWidth,
          circleProperties.velocityX,
          circleProperties.velocityY
        )
      })
    }

    function getRandomVelocity(min, max) {
      return Math.random() * (max - min) + min
    }

    function getRandomPosition(containerDiv, circleWidth) {
      const containerWidth = containerDiv.offsetWidth
      const containerHeight = containerDiv.offsetHeight
      const maxX = containerWidth - circleWidth
      const maxY = containerHeight - circleWidth
      const x = Math.random() * maxX + circleWidth / 2
      const y = Math.random() * maxY + circleWidth / 2
      return {x, y}
    }

    function getRandomDimension(min, max) {
      return Math.round(Math.random() * (max - min) + min)
    }

    const minCircleWidth = 100
    const maxCircleWidth = 250

    containerDivs.forEach((containerDiv) => {
      const bgDiv = containerDiv.querySelector('.discover-bg')
      const circleWidth = getRandomDimension(minCircleWidth, maxCircleWidth)

      const {x: circleX, y: circleY} = getRandomPosition(
        containerDiv,
        circleWidth
      )
      const minVelocity = 0.5 // Define your desired minimum velocity
      const maxVelocity = 3 // Define your desired maximum velocity
      const velocityX = getRandomVelocity(minVelocity, maxVelocity)
      const velocityY = getRandomVelocity(minVelocity, maxVelocity)

      initializeClipPath(bgDiv, circleX, circleY, circleWidth)
      animate(
        containerDiv,
        bgDiv,
        circleX,
        circleY,
        circleWidth,
        velocityX,
        velocityY
      )
    })
  }
}
